import { Injectable } from '@angular/core';
import { LocalStorage } from 'ngx-webstorage';

@Injectable({ providedIn: 'root' })
export class SettingsService {

    @LocalStorage('organizerViewType', '') private organizerViewType;

    constructor() {
    }

    public setOrganizerViewSetting(viewId: string): void {
        this.organizerViewType = viewId;
    }

    public getOrganizerViewSetting(): string {
        return this.organizerViewType;
    }
}
